





































































































import { AppContextEnum } from "@/lib/enum/appContext.enum";
import {
  MrfiktivFleetPermissionDtoGen,
  MrfiktivPermissionDtoGen as PermissionDto
} from "@/services/mrfiktiv/v1/data-contracts";
import { ConfigModule } from "@/store/modules/config";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginCardAuthorizationOverview extends Vue {
  get partnerPermission() {
    if (this.isReport) {
      return UserModule.partnerPermission.filter(p => ReportModule.partner.id === p.id);
    }

    return UserModule.partnerPermission;
  }

  get fleetPermission() {
    if (this.isReport) {
      return UserModule.fleetPermission.filter(p => ReportModule.partner.id === p.partnerId);
    }

    return UserModule.fleetPermission;
  }

  get user() {
    return UserModule.user;
  }

  get isReport() {
    return AppContextEnum.REPORT === ConfigModule.appContext;
  }

  getPartnerName(permission: PermissionDto): string {
    if (this.isReport) {
      return ReportModule.partner.companyName;
    }

    const partner = PartnerModule.partnersMap.get(permission.id);

    if (partner) {
      return partner?.companyName;
    }

    return permission.id;
  }

  getFleetName(permission: MrfiktivFleetPermissionDtoGen): string {
    const fleet = FleetManagerModule.fleets.find(f => f.id === permission.fleetId);

    if (fleet) {
      return fleet?.title;
    }

    return permission.fleetId;
  }
}
